import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "System Administration",
      desc: "Effortlessly manage your Windows systems with expert system administration services.",
      icon: "fas fa-desktop",
    },
    {
      name: "System Support",
      desc: "Get reliable Windows system support for uninterrupted business operations.",
      icon: "fas fa-desktop",
    },
    {
      name: "Web Design",
      desc: "Crafting bespoke web designs to elevate your online brand presence.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Creative Design",
      desc: "Transforming ideas into stunning visuals with custom creative design solutions.",
      icon: "fas fa-paint-brush",
    },
    {
      name: "Business Analysis",
      desc: "Unlock the power of your data with expert business analytics solutions.",
      icon: "fas fa-chart-area",
    },
    {
      name: "Social Media Marketing",
      desc: "Maximize your social media impact with advanced analytics and insights.",
      icon: "fas fa-bullhorn",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
